import React, { useEffect, useState } from 'react'

import type { StarType } from '@/types/components/buying-panel/rating-star'
import type { RatingStarsProps } from '@/types/components/buying-panel/rating-stars'

import { RatingStar } from './RatingStar'

import './RatingStars.scss'
import type { Bottomline } from '@/types/yotpo'

const convertRatingToArr = (rating: number): StarType[] => {
  const roundedStars = (Math.round(rating * 2) / 2).toFixed(1)
  const splitFloat = `${roundedStars}`.split('.')
  const fullStars = splitFloat[0]
  const halfStars = splitFloat[1]
  let starsArray: StarType[] = []

  for (let index = 0; index < parseInt(fullStars); index++) {
    starsArray.push('full')
  }

  if (parseInt(halfStars)) starsArray.push('half')

  if (starsArray.length < 5) {
    const emptyStars = 5 - starsArray.length
    for (let index = 0; index < emptyStars; index++) {
      starsArray.push('empty')
    }
  }

  return starsArray as StarType[]
}

export const RatingStars: React.FC<RatingStarsProps> = ({
  reviewsSectionHref,
  showAverageScore = false,
  productId,
}) => {
  const [bottomline, setBottomline] = useState<Bottomline | null>(null)

  useEffect(() => {
    if (!productId) return

    const fetchBottomline = async () => {
      try {
        const response = await fetch(`/api/products/${productId}/bottomline`)
        if (response.ok) {
          const data = await response.json()
          setBottomline(data)
        }
      } catch (error) {
        console.error('Failed to fetch bottomline', error)
      }
    }

    fetchBottomline()
  }, [productId])

  const displayedRating = bottomline ? bottomline.averageScore : 0
  const displayedCount = bottomline ? bottomline.totalReviews : 0

  const stars: StarType[] = convertRatingToArr(displayedRating)

  return (
    <div className="rating-stars-container">
      <div className="rating-stars">
        {stars.map((starType, index) => (
          <RatingStar key={index} type={starType} />
        ))}
      </div>
      {displayedCount !== undefined && reviewsSectionHref && (
        <a
          href={reviewsSectionHref}
          className="type-label rating-stars__review-count"
        >
          ({displayedCount})
        </a>
      )}
      {showAverageScore && (
        <span className="average-score">{displayedRating.toFixed(1)}</span>
      )}
    </div>
  )
}
